import {
  getPreparationDocuments,
  removePreparationDocument,
  setPreparationDocumentFilters,
  updatePreparationDocument,
} from '@state/reducers/preparationDocumentReducer'
import { GridColumns } from '@mui/x-data-grid-pro'
import { PreparationDocumentDto } from '@services/dtos'
import { useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { AppDispatch } from '@state/store'
import PreparationDocumentForm from '../forms/PreparationDocumentForm'
import { Button, Tooltip } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'

export default function PreparationDocumentsTable() {
  const columns: GridColumns<PreparationDocumentDto> = useMemo(
    () => [
      {
        field: 'compound',
        headerName: 'MRP',
        valueGetter: (params) => params.row.compound?.name || '',
        width: 150,
      },
      {
        field: 'site',
        headerName: 'Site',
        valueGetter: (params) => params.row.site?.label || '',
        width: 150,
      },
      { field: 'label', headerName: 'Label', width: 150 },
      {
        field: 'attachment',
        headerName: 'Document',
        width: 180,
        renderCell: (params) => {
          const url = params.row.attachment?.url
          const filename = params.row.attachment?.filename || 'Document'
          if (!url) {
            return <span style={{ color: '#999' }}>Aucun</span>
          }
          return (
            <Tooltip title={`Consulter le ${filename}`}>
              <Button
                variant="outlined"
                color="primary"
                size="small"
                endIcon={<VisibilityIcon />}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Consulter
              </Button>
            </Tooltip>
          )
        },
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<PreparationDocumentDto>
      columns={columns}
      selectRows={(state) => state.preparationDocument.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setPreparationDocumentFilters({ includeInactive: true }))
        return dispatch(getPreparationDocuments())
      }}
      deleteThunk={removePreparationDocument}
      toggleThunk={(id, isActive) =>
        updatePreparationDocument({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setPreparationDocumentFilters({ page }))
        dispatch(getPreparationDocuments())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <PreparationDocumentForm
          editingPreparationDocument={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="document"
      resourcePrefix="le "
      formMaxWidth="lg"
    />
  )
}
